import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import ComponentButton from '../shared/ComponentButton'

interface Props {
  field: any
  form: any
}

const nextStepInitialTemplate = {
  button: {
    label: '',
    url: '',
    align: 'center',
    hidden: true,
  },
}

const NextStep = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { field, form } = props

  const [nextStep, setNextStep] = useState(() => {
    return field?.value?.content && !_.isEmpty(field.value.content)
      ? field.value.content
      : nextStepInitialTemplate
  })

  useEffect(() => {
    form.setFieldValue(field.name, {
      ...field.value,
      content: nextStep,
    })
  }, [nextStep])

  return (
    <Wrapper>
      <h2>{t('ficheComparative.nextStep.title')}</h2>
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>{t('ficheComparative.nextStep.title')}</label>
            </Col>
            <Col span={24}>
              <Input
                placeholder={t('ficheComparative.nextStep.title')}
                defaultValue={field.value?.title}
                onBlur={e =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    title: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>{t('ficheComparative.nextStep.title')}</label>
            </Col>
            <Col span={24}>
              <Input
                placeholder={t('ficheComparative.nextStep.title')}
                defaultValue={field.value?.subtitle}
                onBlur={e =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    subtitle: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
        </Col>
        <h3>Bouton</h3>
        <ComponentButton parentState={nextStep} setParentState={setNextStep} />
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
`

export default NextStep
